import React from 'react';
import ClassAssembly  from 'views/ClassAssembly10D2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;